import { classes } from 'src/modules/shared/utils/styles.util';
import { DetailsFieldActionSkeleton } from './details-field-action-skeleton';
import { DetailsSkeletonBlock } from './details-skeleton-block';
import type { DetailsFieldListSkeletonVariant } from 'src/modules/communications/types/details-field-list-skeleton.type';

export const DetailsFieldRowSkeleton = ({
  variant,
}: {
  variant: DetailsFieldListSkeletonVariant;
}) => {
  const showEditableActions = variant === 'editable';
  const showAddressActions = variant === 'address';

  return (
    <div className="space-y-0.5 py-1.5">
      <DetailsSkeletonBlock className="h-3 w-20" />

      <div className="flex items-center gap-3">
        <DetailsSkeletonBlock
          className={classes(
            'h-12 flex-1 rounded-xl',
            variant === 'conversation' && 'bg-secondary-100',
            variant === 'editable' && 'bg-secondary-50',
            variant === 'address' && 'bg-call-50'
          )}
        />

        {showEditableActions && (
          <>
            <DetailsFieldActionSkeleton className="h-10 w-10" />
            <DetailsFieldActionSkeleton className="h-10 w-8 rounded-lg" />
          </>
        )}

        {showAddressActions && (
          <>
            <DetailsFieldActionSkeleton className="h-10 w-10 bg-secondary-50" />
            <DetailsFieldActionSkeleton className="h-10 w-10 bg-secondary-50" />
            <DetailsFieldActionSkeleton className="h-10 w-8 rounded-lg bg-secondary-50" />
          </>
        )}
      </div>
    </div>
  );
};
